import styled from 'styled-components';
import { FONTS } from '@app/src/ui';

interface Props {
  background?: string;
  width?: number;
  color?: string;
  loading?: boolean;
  left?: boolean;
  border?: string;
}

export const Wrapper = styled.button`
  position: relative;
  outline: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${FONTS.ROBOTO_BOLD};
  font-size: 15px;
  min-height: 44px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  padding: 0 13px;
  max-width: ${(props:Props) => props.width ? `${props.width}px` : '100%'};
  background: ${(props:Props) => props.background};
  color: ${(props:Props) => props.color};
  border: ${(props:Props) => props.border ? `${props.border}` : '0'};
  &:disabled {
    opacity: .7;
    cursor: not-allowed;
  }
`;

export const Loading = styled.i`
  width: 16px;
  height: 16px;
  position: absolute;
  ${(props: Props) => props.left ? `
    left: 15px;
  ` : `
    right: 15px;
  `};
  &>svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: ${(props:Props) => props.color};
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;
